import { QueryProvider } from './providers/QueryProvider';
import { AppRouter } from './routes';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <QueryProvider>
      <AppRouter />
      <Toaster />
    </QueryProvider>
  );
}

export default App;
